import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  WEBINARS_PROGRESS,
  WEBINARS_SUCCESS,
  WEBINARS_FAILED,
  WEBINARS_GET_LIST_PROGRESS,
  WEBINARS_GET_LIST_SUCCESS,
  WEBINARS_GET_LIST_FAILED,
  WEBINARS_FORM_SUBMIT_PROGRESS,
  WEBINARS_FORM_SUBMIT_SUCCESS,
  WEBINARS_FORM_SUBMIT_FAILED,
  WEBINARS_GET_WEBINAR_PROGRESS,
  WEBINARS_GET_WEBINAR_SUCCESS,
  WEBINARS_GET_WEBINAR_FAILED,
  WEBINARS_CLEAR_STATE,
  WEBINARS_CLEAR_FLASH_MESSAGE,
} from '../actions/webinarsActions';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case WEBINARS_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        loadListStatus: { $set: WEBINARS_PROGRESS },
      });
    }
    case WEBINARS_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.webinars },
        loadListStatus: { $set: WEBINARS_SUCCESS },
      });
    }
    case WEBINARS_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        loadListStatus: { $set: WEBINARS_FAILED },
      });
    }
    case WEBINARS_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: WEBINARS_PROGRESS } });
    }
    case WEBINARS_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: WEBINARS_SUCCESS },
      });
    }
    case WEBINARS_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: WEBINARS_FAILED } });
    }
    case WEBINARS_GET_WEBINAR_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: WEBINARS_PROGRESS },
      });
    }
    case WEBINARS_GET_WEBINAR_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.webinar },
        loadActiveStatus: { $set: WEBINARS_SUCCESS },
      });
    }
    case WEBINARS_GET_WEBINAR_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: WEBINARS_FAILED },
      });
    }
    case WEBINARS_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case WEBINARS_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
